/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import homepage from './homepage'
import system from './system'
import product from './product'
import request from './request'
import research from './research'
import administration from './administration'
import statistics from './statistics'
import internalTools from './internalTools'

// Array of sections
// export default [...homepage, ...dashboard, ...appsAndPages, ...uiElements, ...formAndTable, ...chartsAndMaps, ...others]
export default [...homepage, ...statistics, ...product, ...request, ...administration, ...research, ...system, ...internalTools]
